<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab key="CA">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - A
      </v-tab>
      <v-tab key="CB1">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - B1
      </v-tab>
      <v-tab key="CB2">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - B2
      </v-tab>
      <!-- :disabled="accion===1" -->
      <!--Inicia tab Categoria A-->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6">
                Corrección de Expedientes
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <!--v-btn
              color=""
              dark
              class="mb-2 float-right blue-grey darken-2"
              :to="{name: 'expedientes-ingreso'}"
            >
              Registrar Expediente
            </!--v-btn-->
              </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsA"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.no_Expediente }}
                  </td>
                  <td>{{ item.nombre_Proyecto }}</td>
                  <td>
                    {{ item.descripcion_Proyecto }}
                  </td>
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : item.estadosExpedienteId === 10
                          ? 'cyan lighten-3'
                          : item.estadosExpedienteId === 11
                          ? 'pink lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : item.estadosExpedienteId === 10
                          ? 'light-blue darken-4'
                          : item.estadosExpedienteId === 11
                          ? 'pink darken-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                    </v-chip>
                  </td>
                  <!--td>
                    <v-btn
                      class="
                    ma-2
                    btn-bg-light
                    blue-grey--text
                    lighten-2--text
                    font-weight-medium
                    text-capitalize
                  "
                      small
                      depressed
                      color="blue-grey lighten-5"
                      :to="{
                        name: 'visualizar-expediente',
                        params: { id: item.id, tipo: 1 },
                      }"
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                  </!--td-->
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 &&
                        (item.estadosExpedienteId === 26 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="agregarDictamen(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="item.resolucion > 0"
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="obtenerExpedienteDictamenes(item.id)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template> -->
        </v-card>
      </v-tab-item>
      <!-- Categoria B> -->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes </v-col>
              <v-col cols="12" sm="12" md="6">
                <!--v-btn
              color=""
              dark
              class="mb-2 float-right blue-grey darken-2"
              :to="{name: 'expedientes-ingreso'}"
            >
              Registrar Expediente
            </!--v-btn-->
              </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsB1"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.no_Expediente }}
                  </td>
                  <td>{{ item.nombre_Proyecto }}</td>
                  <td>
                    {{ item.descripcion_Proyecto }}
                  </td>
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-4'
                          : item.estadosExpedienteId === 2
                          ? 'cyan lighten-4'
                          : item.estadosExpedienteId === 3
                          ? 'amber'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-1'
                          : item.estadosExpedienteId === 2
                          ? 'cyan darken-1'
                          : item.estadosExpedienteId === 3
                          ? 'deep-orange darken-4'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 && item.estadosExpedienteId === 26
                      "
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="agregarDictamen(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="item.resolucion > 0"
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="obtenerExpedienteDictamenes(item.id)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template> -->
        </v-card>
      </v-tab-item>
      <!-- Categoría B2 -->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes </v-col>
              <v-col cols="12" sm="12" md="6">
                <!--v-btn
              color=""
              dark
              class="mb-2 float-right blue-grey darken-2"
              :to="{name: 'expedientes-ingreso'}"
            >
              Registrar Expediente
            </!--v-btn-->
              </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsB2"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.no_Expediente }}
                  </td>
                  <td>{{ item.nombre_Proyecto }}</td>
                  <td>
                    {{ item.descripcion_Proyecto }}
                  </td>
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-4'
                          : item.estadosExpedienteId === 2
                          ? 'cyan lighten-4'
                          : item.estadosExpedienteId === 3
                          ? 'amber'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-1'
                          : item.estadosExpedienteId === 2
                          ? 'cyan darken-1'
                          : item.estadosExpedienteId === 3
                          ? 'deep-orange darken-4'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 && item.estadosExpedienteId === 26
                      "
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="agregarDictamen(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                    <v-btn
                      v-if="item.resolucion > 0"
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="obtenerExpedienteDictamenes(item.id)"
                    >
                      <v-icon left>fas fa-edit</v-icon> Resolución
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template> -->
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogAnalisis"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Análisis del Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogAnalisis = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>¿Desea iniciar el análisis del siguiente expediente?</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogAnalisis = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(13)"
            :loading="btnEnvioAnalisis"
          >
            Sí, iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <!--begin:: crear dictamen -->
    <v-dialog
      v-model="dialogCrearDictamen"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Crear Dictamen

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnCreaDictamen"
            @click="dialogCrearDictamen = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>
                ¿Está seguro que desea crear la resolución del siguiente
                expediente?
              </h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogCrearDictamen = false"
            :disabled="btnCreaDictamen"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="registrarItemDictamen"
            :loading="btnCreaDictamen"
          >
            Sí, crear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogAnalisis"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Análisis del Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogAnalisis = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>¿Desea iniciar el análisis del siguiente expediente?</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogAnalisis = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(13)"
            :loading="btnEnvioAnalisis"
          >
            Sí, iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogSolicitud"
      width="800"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Solicitud Vista Pública

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSolicitud = false" class="float-right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Fecha de la Solicitud</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.fecha
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Fotocopia Dpi</v-list-item-title
                  >
                  <v-btn
                    small
                    block
                    class="blue--text lighten-2--text text-capitalize"
                    color="blue lighten-5"
                    @click="descargarArchivo(solicitud.path)"
                  >
                    <v-icon left>mdi-file-download-outline</v-icon>
                    Descargar
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Expediente</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.no_Expediente
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Nombre del Proyecto</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.nombre_Proyecto
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Nombre del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.nombre
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Dpi del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.dpi
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >No. de Teléfono del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.no_Telefono
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Correo del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Motivo de la Solicitud</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.motivo
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="red--text"
            dark
            color="red lighten-4"
            :loading="btnRegistroRequisitoLoading"
            @click="cambiarEstadoSolicitud(solicitud.id, 2)"
          >
            <v-icon left>fas fa-user-times</v-icon>Rechazar
          </v-btn>
          <!--:disabled="!validDocForm" type="submit"-->
          <v-btn
            class="green--text"
            dark
            color="teal lighten-5"
            :loading="btnRegistroRequisitoLoading"
            @click="cambiarEstadoSolicitud(solicitud.id, 1)"
          >
            <v-icon left> fas fa-user-check</v-icon>Aprobar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: modal registro-->
    <v-dialog
      v-model="dialogDictamen"
      max-width="1200"
      transition="scroll-y-transition"
      persistent
      scrollable
    >
      <v-card tile>
        <v-card-title>
          Resolución

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDictamen = false" class="float-right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="d-none"></v-divider>

        <v-card-text class="pl-8 pr-8 pt-5">
          <v-form
            ref="form"
            v-on:submit.prevent="registrarItemDictamen"
            v-model="validFormDictamen"
          >
            <!--v-row>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                <v-autocomplete
                  v-model="datosItemResolucion.dictamenId"
                  :items="dictamenes"
                  class="required"
                  dense
                  filled
                  label="Dictamen"
                  item-text="nombre"
                  item-value="id"
                  :loading="ddlDictamenesLoading"
                  :rules="[selectRequired('Dictamen')]"
                ></v-autocomplete>
              </v-col>
            </!--v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn
                color="grey lighten-5"
                elevation="0"
                class="mb-2 float-right grey lighten-5"
                @click="
                  dialogDictamen = false;
                  resetFormDictamen();
                "
                :disabled="btnRegistroDictamenLoading"
              >
                Cancelar
              </v-btn>
              <:disabled="!validDocForm" type="submit">
              <v-btn
                color="primary"
                class="mb-2 float-right"
                type="submit"
                :elevation="0"
                :disabled="!validFormDictamen"
                :loading="btnRegistroDictamenLoading"
              >
                Guardar
              </v-btn>
            </v-row-->
            <v-row>
              <v-col cols="12" md="12" sm="12" xs="12">
                <v-data-table
                  class="elevation-0"
                  :headers="headerDictamen"
                  :items="itemsDictamen"
                  :loading="tableDictamenLoading"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-chevron-left',
                    nextIcon: 'mdi-chevron-right',
                    'items-per-page-text': 'Registros por página',
                    pageText: '{0}-{1} de {2}',
                  }"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.nombre }}</td>
                      <td>{{ item.fecha_Creacion }}</td>
                      <td>{{ item.usuario_Creacion }}</td>
                      <td>
                        <v-btn
                          v-if="item.pathPdfOld"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarArchivoBackend(item.pathPdfOld)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarArchivoBackend(item.pathDictamen)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          v-if="item.tipoAprobacion === 1"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarPlantillaWord(item.expedienteId, 1)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar Aprobatoria
                        </v-btn>
                        <v-btn
                          v-if="item.tipoAprobacion === 2"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarPlantillaWord(item.expedienteId, 2)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar No Aprobatorio
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="
                            mostrarModalCargaDocumento(
                              item.id,
                              item.nombrePlantilla
                            )
                          "
                        >
                          <v-icon left>mdi-cloud-upload</v-icon> Cargar
                          Documento
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          v-if="item.pathPdf"
                          class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                          small
                          depressed
                          color="blue-grey lighten-5"
                          @click="descargarArchivoBackend(item.pathPdf)"
                        >
                          <v-icon left>mdi-file-download-outline</v-icon>
                          Descargar
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>

    <!--begin:: dialog carga de documento -->
    <v-dialog
      v-model="dialogCargaDocumento"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Cargar Resolución

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnCargaDocLoading"
            @click="dialogCargaDocumento = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="formDoc"
            v-on:submit.prevent="cargarArchivo"
            v-model="validFormDocumento"
          >
            <v-row>
              <v-col cols="12" md="12" sm="12" class="pt-0 mt-4 pb-0 mb-0">
                <v-subheader class="text-h6 text-uppercase">
                  {{ documentoSeleccionado }}
                </v-subheader>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="pt-0 mt-4 pb-0 mb-0">
                <template>
                  <v-file-input
                    id="docFile"
                    dense
                    filled
                    placeholder="Seleccionar archivo .docx"
                    accept=".docx"
                    :label="'Seleccione para ' + documentoSeleccionado"
                    append-icon="fa-file-word"
                    prepend-icon=""
                    @change="onFileChange"
                    :rules="[fileRequired('documento')]"
                    :show-size="1000"
                    ref="docFile"
                    class="required"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip v-if="index < 2" small label color="primary">
                        {{ text }}
                      </v-chip>
                      <span
                        v-else-if="index === 2"
                        class="text-overline grey--text text--darken-3 mx-2"
                      >
                        +{{ files.length - 2 }} archivo(s)
                      </span>
                    </template>
                  </v-file-input>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-btn
                  class="float-right m-1"
                  color="indigo"
                  dark
                  type="submit"
                  :loading="btnCargaDocLoading"
                  :disabled="!validFormDocumento"
                >
                  Cargar documento
                </v-btn>
                <v-btn
                  class="float-right white--text m-1"
                  color="blue-grey darken-2"
                  @click="dialogCargaDocumento = false"
                  :disabled="btnCargaDocLoading"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--fin:: dialog carga de documento -->
    <!--begin:: dialog envío expediente -->
    <v-dialog
      v-model="dialogEnviar"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Enviar a Director

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogEnviar = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>
                ¿Está seguro que desea enviar al director el siguiente
                expediente?
              </h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogEnviar = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(14)"
            :loading="btnEnvioAnalisis"
          >
            Sí, enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: dialog envío expediente -->
    <!--Dialog loader -->
    <DialogLoader
      :dialogVisible="dialogLoaderVisible"
      :text="dialogLoaderText"
      transition="scroll-y-transition"
    ></DialogLoader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DialogLoader from "@/view/content/DialogLoader";
import SnackAlert from "@/view/content/alerts/SnackAlert.vue";

import validations from "@/core/untils/validations.js";
import { ACTUALIZAR_ESTADO_EXPEDIENTE } from "@/core/services/store/expedientes/expedientes.module";
import { OBTENER_EXPEDIENTES_BY_CATEGORIA3 } from "@/core/services/store/expedientes/expedientes.module";
import { OBTENER_DICTAMENES } from "@/core/services/store/dictamenes/dictamenes.module";
import {
  REGISTRAR_RESOLUCION_EXPEDIENTE,
  OBTENER_RESOLUCIONES_EXPEDIENTE,
  OBTENER_DICTAMEN_EXPEDIENTE,
  ACTUALIZAR_RESOLUCION_EXPEDIENTE,
} from "@/core/services/store/resoluciones/expedienteresolucion.module";
import { OBTENER_PATH_RESOLUCION_PLANTILLA } from "@/core/services/store/expedientes/dictamenPlantilla/resolucionPlantilla.module";
import { CARGAR_ARCHIVO } from "@/core/services/store/cargaarchivo.module";
import JwtService from "@/core/services/jwt.service";
/*
import {OBTENER_CONTACTOS, REGISTRAR_CONTACTO} from "@/core/services/store/contactos/contacto.module";
import classSet from '../../../../assets/plugins/formvalidation/src/js/utils/classSet';
*/

export default {
  name: "AdminExpedientes",
  data() {
    return {
      tab: null,
      tabContactosDisabled: true,
      tableLoading: false,
      validForm: false,
      dialogEnvio: false,

      btnEnvioLoading: false,
      btnRegistroContactoLoading: false,
      contactos: [],
      tableContactosLoading: false,
      ddRolesLoading: false,
      dialogRegistro: false,
      dialogLoaderVisible: false,
      dialogLoaderText: "",
      switchItemEstado: true,
      proyectoSeleccionado: "",
      filtro: "",
      tipoContactoSeleccionado: {},
      dialog: false,
      dialogTitle: "Registrar nuevo proyecto",
      accion: 1,
      btnRegistroText: "Guardar",
      btnRegistroLoading: false,
      estadoProyecto: "",
      items: [],
      cargos: [],
      estadosProyecto: [
        { text: "Todos", value: null },
        { value: 26, text: "Corrección Proc" },
        // { value: 2, text: "Analisis" },
        // { value: 3, text: "Ampliacion" },
      ],
      ...validations,
      tableALoading: false,
      itemsA: [],
      tableB1Loading: false,
      itemsB1: [],
      tableB2Loading: false,
      itemsB2: [],
      dialogAnalisis: false,
      btnEnvioAnalisis: false,
      datosEnvioItem: {
        id: 0,
        estadoExpedienteId: 0,
        usuario: "admin",
      },
      datosEnvioEmail: {
        id: 0,
        estadoSolicitudId: 0,
        usuario_Actualizacion: "admin",
      },
      solicitudes: [],
      filtroSolicitudes: "",
      tableSolicitudesLoading: false,
      dialogSolicitud: false,
      solicitud: {},
      dialogDictamen: false,
      validFormDictamen: false,
      btnRegistroDictamenLoading: false,
      datosItemResolucion: {
        id: 0,
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        resolucionId: 1,
        expedienteId: 0,
        pathWord: "",
      },
      dictamenes: [],
      itemsDictamen: [],
      tableDictamenLoading: false,
      ddlDictamenesLoading: false,
      dialogCrearDictamen: false,

      btnCargaDocLoading: false,
      dialogCargaDocumento: false,
      validFormDocumento: false,
      documentoSeleccionado: "",
      archivoCargado: false,
      archivo: [],
      expedienteId: 0,
      resolucionExpedienteId: 0,
      nombrePlantilla: "",
      dialogEnviar: false,
    };
  },
  components: {
    DialogLoader,
    SnackAlert,
  },
  methods: {
    resetFormDictamen() {
      this.datosItemResolucion = {
        id: 0,
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        resolucionId: 1,
        expedienteId: 0,
      };
    },
    agregarDictamen(id, nombreProyecto) {
      this.dialogCrearDictamen = true;
      this.proyectoSeleccionado = nombreProyecto;
      this.expedienteId = id;
      this.datosItemResolucion.expedienteId = id;
      // this.obtenerDictamenes();
      // this.obtenerExpedienteDictamenes(id);
      // this.datosItemResolucion.expedienteId = id;
      // this.dialogDictamen = true;
      // this.accion = 1;
    },
    //Mostrar el dialogo para la suspension
    enviarDirector(id, nombreProyecto) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = id;
      this.proyectoSeleccionado = nombreProyecto;
      this.dialogEnviar = true;
      this.dialogLoaderVisible = false;
    },
    verSolicitud(id) {
      this.obtenerSolicitud(id);
    },
    filtroEstado(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.estadoProyecto.value) {
        return true;
      }
      //console.log(value);
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value === this.estadoProyecto.text;
    },
    //Mostrar el dialogo para la suspension
    iniciarAnalisis(id, nombreProyecto, estadosExpedienteId) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = id;
      this.proyectoSeleccionado = nombreProyecto;
      console.log(estadosExpedienteId);

      if (estadosExpedienteId === 12) {
        this.dialogAnalisis = true;
      } else if (estadosExpedienteId === 26 || estadosExpedienteId === 29) {
        this.$router.push({
          name: "vista-procurador",
          params: { id: this.datosEnvioItem.id },
        });
      }
      this.dialogLoaderVisible = false;
    },
    // Obtener los items
    async obtenerDictamenes() {
      this.dictamenes = [];
      this.ddlDictamenesLoading = true;

      this.$store
        .dispatch(OBTENER_DICTAMENES, 1)
        .then((res) => {
          if (res.status === 200) {
            this.dictamenes = this.$store.state.dictamenes.dictamenes;
          }
          //console.log(this.solicitudes);
          this.ddlDictamenesLoading = false;
        })
        .catch(() => {
          this.ddlDictamenesLoading = false;
        });
    },
    // Obtener los items expediente dictamen
    async obtenerExpedienteDictamenes(id) {
      this.itemsDictamen = [];
      this.tableDictamenLoading = true;

      this.$store
        .dispatch(OBTENER_RESOLUCIONES_EXPEDIENTE, id)
        .then((res) => {
          if (res.status === 200) {
            this.itemsDictamen =
              this.$store.state.expedienteresolucion.resolucionesExpediente;
            //console.log(this.itemsDictamen);
            this.dialogDictamen = true;
            this.expedienteId = id;
            //console.log(this.expedienteId);
          }
          //console.log(this.solicitudes);
          this.tableDictamenLoading = false;
        })
        .catch(() => {
          this.tableDictamenLoading = false;
        });
    },
    //async obtenerSolicitud(Id) {
    //  this.dialogLoaderVisible = true;
    //  this.$store
    //    .dispatch(OBTENER_SOLICITUD_VP, Id)
    //    .then((res) => {
    //      if (res.status === 200) {
    //        this.solicitud = this.$store.state.solicitudvp.solicitudVP;
    //        this.dialogSolicitud = true;
    //      }
    //      this.dialogLoaderVisible = false;
    //    })
    //    .catch(() => {
    //      this.dialogLoaderVisible = false;
    //    });
    //},
    //!Obtener datos de un item especifico
    obtenerDatosItem(Id) {
      this.dialogLoaderVisible = true;
      this.dialogLoaderText = "Obteniendo información...";
      this.$store
        .dispatch(OBTENER_DICTAMEN_EXPEDIENTE, Id)
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.datosItemResolucion =
              this.$store.state.expedientedictamen.dictamenExpediente;
            this.accion = 2;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
          );
          this.dialogLoaderVisible = false;
        });
    },

    /// Obtener los items
    async obtenerItemsA() {
      this.itemsA = [];
      this.tableALoading = true;

      this.$store
        .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA3, {
          categoriaId: 1,
          tipoBandeja: 6,
          //usuarioMarnId: this.currentUser.id,
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsA = this.$store.state.expedientes.expedientes;
          }
          console.log(this.itemsA);
          this.tableALoading = false;
        })
        .catch(() => {
          this.tableALoading = false;
        });
    },
    /// Obtener los items
    async obtenerItemsB1() {
      this.itemsB1 = [];
      this.tableB1Loading = true;

      this.$store
        .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA3, {
          categoriaId: 2,
          tipoBandeja: 6,
          //usuarioMarnId: this.currentUser.id,
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsB1 = this.$store.state.expedientes.expedientes;
          }
          //console.log(this.items);
          this.tableB1Loading = false;
        })
        .catch(() => {
          this.tableB1Loading = false;
        });
    },
    /// Obtener los items
    async obtenerItemsB2() {
      this.itemsB2 = [];
      this.tableB2Loading = true;

      const userId = JwtService.getUserId();

      this.$store
        .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA3, {
          categoriaId: 3,
          tipoBandeja: 6,
          id: userId, // Pasar el nuevo parámetro id
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsB2 = this.$store.state.expedientes.expedientes;
          }
          //console.log(this.items);
          this.tableB2Loading = false;
        })
        .catch(() => {
          this.tableB2Loading = false;
        });
    },
    //Enviar el expediente
    async enviarExpediente(estado) {
      //10 = analisis, 12 = procurador
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.estadoExpedienteId = estado;
      await this.$store
        .dispatch(ACTUALIZAR_ESTADO_EXPEDIENTE, this.datosEnvioItem)
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.expedienteRegistrado = 1;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            // if (estado === 10) {
            //   this.$router.push({
            //     name: "vista-asesor",
            //     params: { id: this.datosEnvioItem.id },
            //   });
            // } else if (estado === 12) {
            this.obtenerItemsA();
            this.obtenerItemsB1();
            this.obtenerItemsB2();
            //}
            this.dialogEnviar = false;
            this.dialogAnalisis = false;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    //Registro de categorias
    registrarItemDictamen() {
      this.btnRegistroLoading = true;
      this.dialogLoaderVisible = true;
      if (this.accion === 1) {
        this.$store
          .dispatch(REGISTRAR_RESOLUCION_EXPEDIENTE, this.datosItemResolucion)
          .then((res) => {
            this.btnLoading = false;
            if (res.status === 200) {
              this.$refs.snackalert.SnackbarShow(
                "success",
                "Mensaje",
                res.message
              );
              this.obtenerExpedienteDictamenes(
                this.datosItemResolucion.expedienteId
              );
              this.resetFormDictamen();
              this.obtenerItemsA();
              this.obtenerItemsB1();
              this.obtenerItemsB2();
              this.dialogCrearDictamen = false;
            } else {
              this.$refs.snackalert.SnackbarShow(
                "warning",
                "Alerta",
                res.message
              );
            }
            this.btnRegistroLoading = false;
            this.dialogLoaderVisible = false;
          })
          .catch(() => {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error durante el registro.`
            );
          });
      }
      //?Si accion es 2 se realiza la actualizacion
      else {
        this.$store
          .dispatch(ACTUALIZAR_RESOLUCION_EXPEDIENTE, this.datosItemResolucion)
          .then((res) => {
            if (res.status === 200) {
              this.$refs.snackalert.SnackbarShow(
                "success",
                "Mensaje",
                res.message
              );
              this.obtenerExpedienteDictamenes(
                this.datosItemResolucion.expedienteId
              );
              this.resetFormDictamen();
            } else {
              this.$refs.snackalert.SnackbarShow(
                "warning",
                "Alerta",
                res.message
              );
            }
            this.btnRegistroLoading = false;
            this.dialogLoaderVisible = false;
          })
          .catch(() => {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error durante el registro.`
            );
          });
      }
    },
    async cargarArchivoWord(path) {
      this.datosItemResolucion.id = this.resolucionExpedienteId;
      this.datosItemResolucion.expedienteId = this.expedienteId;
      this.datosItemResolucion.pathWord = path;
      await this.$store
        .dispatch(ACTUALIZAR_RESOLUCION_EXPEDIENTE, this.datosItemResolucion)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.obtenerExpedienteDictamenes(
              this.datosItemResolucion.expedienteId
            );
            this.resetFormDictamen();
            this.dialogCargaDocumento = false;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.mensaje
            );
          }
          //this.btnRegistroLoading = false;
          this.btnCargaDocLoading = false;
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.btnCargaDocLoading = false;
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },

    descargarPlantillaWord(Id, tipo) {
      this.dialogLoaderVisible = true;
      this.$store
        .dispatch(OBTENER_PATH_RESOLUCION_PLANTILLA, {
          expedienteId: Id,
          tipo: tipo,
        })
        .then((res) => {
          if (res.status === 200) {
            this.descargarArchivoBackend(res.message);
            this.obtenerExpedienteDictamenes(this.expedienteId);
            //console.log(res);
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
          //console.log(this.items);
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
        });
    },
    descargarArchivoBackend(path) {
      let newPath = path.replace(/\\/g, "/");
      //server
      window.open("http://preprod-wsayb.marn.gob.gt" + newPath, "_blank");
      //local
      //window.open("https://localhost:44396" + newPath, "_blank");
    },
    descargarArchivo(path) {
      let newPath = path.replace(/\\/g, "/");
      //console.log(newPath);
      window.open("http://preprod-interface.marn.gob.gt" + newPath, "_blank");
    },
    // Tipo: 1 REquisito, 2 TDR
    mostrarModalCargaDocumento(id, nombre) {
      let fileNameWithoutExtension = nombre.substring(
        0,
        nombre.lastIndexOf(".")
      );
      this.nombrePlantilla = fileNameWithoutExtension;
      this.resolucionExpedienteId = id;
      //this.tipoRequisitoId = tipo;
      //this.documentoSeleccionado = documento;
      this.dialogCargaDocumento = true;
      //this.datosRequisitoExpediente.asigAcuerdoRequisitosId = asigAcuerdoRequisitosId;
    },
    onFileChange(e) {
      if (e) {
        let fileName = e.name;
        let fileNameWithoutExtension = fileName.substring(
          0,
          fileName.lastIndexOf(" ")
        );
        if (fileNameWithoutExtension === "") {
          fileNameWithoutExtension = fileName.substring(
            0,
            fileName.lastIndexOf(".")
          );
        }
        console.log(this.nombrePlantilla);
        console.log(fileName);
        if (this.nombrePlantilla !== fileNameWithoutExtension) {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El nombre del archivo no es igual al de la plantilla descargada.`
          );
          // this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }
        //this.datosRequisitoExpediente.nombreDocumento = e.name;
        //!?Validar que el tipo de archivo sea pdf
        if (
          e.type !=
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          // Api call
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El archivo que desea ingresar no es válido.`
          );
          //console.log("no es un pdf..")
          //this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }
        //?Validar que el tamaó del archivo no exceda los 10Mb
        if (e.size / 1024 / 1024 > 10) {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El tamaño del archivo excede el límite permitido (10Mb)`
          );
          // this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }

        this.archivo = e;
      }
    },
    async cargarArchivo() {
      this.dialogLoaderVisible = true;
      this.btnCargaDocLoading = true;
      const files = this.archivo;
      let path = `\\resolucion\\expedientes\\${this.expedienteId}\\procurador\\`;
      //this.datosArchivo={};

      await this.$store
        .dispatch(CARGAR_ARCHIVO, { file: files, path: path })
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.archivoCargado = true;
            //this.datosRequisitoExpediente.path = res.pathArchivo;
            this.cargarArchivoWord(res.pathArchivo);

            this.$refs.docFile.reset();
            document.querySelector("#docFile").value = "";
          } else {
            this.dialogLoaderVisible = false;
            this.btnCargaDocLoading = false;
            this.archivoCargado = false;
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.mensaje
            );
            //this.btnRegistroLoading=false;
          }
        })
        .catch((error) => {
          this.$refs.snackalert("warning", "Alerta", error);
          this.dialogLoaderVisible = false;
          this.btnCargaDocLoading = false;
          this.archivoCargado = false;
        });
    },
  },
  created() {
    this.obtenerItemsB2();
    this.obtenerItemsB1();
    this.obtenerItemsA();
    //this.obtenerSolicitudes();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inicio", route: "/dashboard" },
      { title: "Procurador" },
    ]);
  },

  computed: {
    // currentUser: {
    //   get() {
    //     return this.$store.state.auth.user;
    //   },
    // },
    headers() {
      return [
        {
          text: "Track Id",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "No. Expediente",
          align: "start",
          sortable: false,
          value: "no_Expediente",
        },
        {
          text: "Nombre del proyecto",
          align: "start",
          sortable: true,
          value: "nombre_Proyecto",
        },
        {
          text: "Descripción",
          align: "start",
          sortable: true,
          value: "descripcion_Proyecto",
        },
        /*{
            text: "Máxima autoridad",
            align: "start",
            sortable: true,
            value: "institucion"
          },*/
        {
          text: "Estado",
          align: "start",
          sortable: true,
          value: "estadoExpediente",
          filter: this.filtroEstado,
        },
        {
          text: "Acciones",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
    headerDictamen() {
      return [
        {
          text: "Resolución",
          align: "start",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Fecha Ingreso",
          align: "start",
          sortable: false,
          value: "fecha_Creacion",
        },
        {
          text: "Usuario Ingreso",
          align: "start",
          sortable: false,
          value: "usuario_Creacion",
        },
        {
          text: "Documento Anterior",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Nuevo Dictamen",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Plantilla Word",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Cargar Resolución",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Documento",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
  },
};
</script>
